/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TranslateTextDto } from '../../models/translate-text-dto';
import { TranslateTextResponseDto } from '../../models/translate-text-response-dto';

export interface AutomaticTranslationControllerTranslateText$Params {
  
    /**
     * Text to be translated
     */
    body: TranslateTextDto
}

export function automaticTranslationControllerTranslateText(http: HttpClient, rootUrl: string, params: AutomaticTranslationControllerTranslateText$Params, context?: HttpContext): Observable<StrictHttpResponse<TranslateTextResponseDto>> {
  const rb = new RequestBuilder(rootUrl, automaticTranslationControllerTranslateText.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TranslateTextResponseDto>;
    })
  );
}

automaticTranslationControllerTranslateText.PATH = '/automatic-translation/translate-text';
